import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultAttributeValuesData = {
  id: 0,
  enabled: true,
  name: '',
  quantity: 1,
  attributeId: '',
  attribute: {
    id: null
  }
};
export const getAttributesValues = params => request({
  url: '/attributes-values',
  method: 'get',
  params
});
export const getAttributesValuesById = id => request({
  url: `/attributes-values/${id}`,
  method: 'get'
});
export const updateAttributesValues = (id, data) => request({
  url: `/attributes-values/${id}`,
  method: 'patch',
  data
});
export const deleteAttributesValues = id => request({
  url: `/attributes-values/${id}`,
  method: 'delete'
});
export const createAttributesValues = data => request({
  url: '/attributes-values/',
  method: 'post',
  data
});